var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginFormView',{attrs:{"loading":_vm.loading,"error":_vm.error},on:{"login":_vm.login,"change-password":_vm.changePassword}})}
var staticRenderFns = []

export { render, staticRenderFns }